/**
 * Service to handle generating a results data visualization image.
 *
 * @module DataVisualizationService
 */
var DataVisualizationService = (function() {

  /**
   * The constructor for the service's class.
   * @constructor
   */
  function Service() {

  }

  /**
   * Method to generate a breed visualization image.
   */
  Service.prototype.initialize = function(type, results, callback) {

    this.type = type || "breed";
    this.results = results;
    this.callback = callback;

    // @see: src/scripts/classes/CanvasContext.js
    this.baseCanvas = new CanvasContext({
      width: 1000,
      height: 1000,
      fill: "#fff",
    });

    //
    if (this.type === "breed") {
      this.renderBreedVisualization();
    } else {
      this.renderAgeVisualization();
    }

    // HACK: Append the canvas to the DOM
    // document.body.innerHTML = "";
    // document.body.appendChild(this.baseCanvas.element);

  };

  /**
   * Method to generate a breed visualization image.
   */
  Service.prototype.renderBreedVisualization = function() {

    this.resultsCanvas = new CanvasContext({ width: 2000, height: 2000 });

    this.profileSize = 300;

    this.profilePosition = {
      x: (this.resultsCanvas.element.width - this.profileSize) / 2,
      y: (this.resultsCanvas.element.height - this.profileSize) / 2,
    };

    this.renderBreedResults();

  };

  /**
   * Method to render the age results to the canvas.
   */
  Service.prototype.renderBreedResults = function() {

    var size = { min: 300, max: 900 }; // 150, 450

    var colors = [
      "#F36D00",
      "rgba(3, 109, 255, 0.9)", //"#036DFF",
      "#FFE833",
      "rgba(0, 136, 81, 0.9)", // "#008851",
      "#FFAA00",
      "rgba(255, 219, 209, 0.9)", // "#FFDBD1",
      "rgba(153, 207, 185, 0.9)", // "#99CFB9",
      "rgba(232, 73, 76, 0.9)", // "#E8494C",
    ];

    var baseElement = this.baseCanvas.element;
    var resultsElement = this.resultsCanvas.element;

    this.results.forEach(function(result, index, results) {
      // @see: src/services/breed.php - dnamydog_results_breed_get_diameter
      var diameter = size.min + ((size.max - size.min) * (result.value / 100));
      var offset = this.getBreedResultPosition(diameter, index, results.length);
      this.resultsCanvas.drawCircle({
        x: (resultsElement.width / 2) + offset.x,
        y: (resultsElement.height / 2) + offset.y,
        radius: diameter / 2,
        fill: colors[index],
      });
    }, this);

    var self = this;

    this.createProfileImage(this.resultsCanvas, function() {

      self.resultsCanvas.trimCanvas();

      var width = resultsElement.width;
      var height = resultsElement.height;
      var ratio = 0.95;

      // Handle images that might be larger, scale them down proportionally
      if (
        width > baseElement.width * ratio
        || height > baseElement.height * ratio
      ) {
        if (width > height) {
          width = baseElement.width * ratio;
          height = width * (height / width);
        } else {
          height = baseElement.height * ratio;
          width = width / (width / height);
        }
      }

      self.baseCanvas.drawImage({
        image: resultsElement,
        x: (baseElement.width - width) / 2,
        y: (baseElement.height - height) / 2,
        width: width,
        height: height,
      });

      self.callback(self.baseCanvas);

    });

  };

  /**
   * Function to get element position based on the size and index.
   */
  Service.prototype.getBreedResultPosition = function(diameter, index, count) {

    // @see: src/services/breed.php - dnamydog_results_breed_get_margin

    // Get margin for 45 degree circles and ensure the edge meets the centre
    // TODO: Write calc more concisely
    var radius = diameter / 2;
    // Diagonal of the square the circle is inscribed in
    // TODO: Specify "magic" number as variable with link to description
    var diagonal = diameter * 1.414;
    // Distance from point where diagnoal meets circle to closet corner
    var distance = (diagonal - diameter) / 2;
    // Distance above becomes diagonal of square.
    // Calculate side to know how much to shift both ways.
    var edge = Math.pow(distance / 2, 2) + Math.pow(distance / 2, 2);
    // TODO: Add additional comments here
    var side = Math.sqrt(edge);
    // TODO: Add additional comments here
    var offset = radius - side;

    // Handle an edge case in the design to keep the layout balanced
    if (count === 2) {
      switch(index) {
        // Bottom-Right
        case 0: return { x: offset, y: offset };
        // Top-Left
        case 1: return { x: -offset, y: -offset };
        // None
        default: return { x: 0, y: 0 };
      }
    }

    // Otherwise lay the circle out start at the 45 angles in the bottom-right
    // After the first 4, the positions shift to 90 angles
    switch(index) {
      // Bottom-Right
      case 0: return { x: offset, y: offset };
      // Bottom-Left
      case 1: return { x: -offset, y: offset };
      // Top-Right
      case 2: return { x: -offset, y: -offset };
      // Top-Left
      case 3: return { x: offset, y: -offset };
      // Bottom
      case 4: return { x: radius, y: 0 };
      // Left
      case 5: return { x: 0, y: radius };
      // Top
      case 6: return { x: -radius, y: 0 };
      // Right
      case 7: return { x: 0, y: -radius };
      // None
      default: return { x: 0, y: 0 };
    }

  };

  /**
   * Method to generate an age visualization image.
   */
  Service.prototype.renderAgeVisualization = function() {

    this.profileSize = 310;

    this.profilePosition = {
      x: (this.baseCanvas.element.width - this.profileSize) / 2,
      y: 40,
    };

    this.renderAgeResults();

  };

  /**
   * Method to render the age results to the canvas.
   */
  Service.prototype.renderAgeResults = function() {

    var self = this;
    var value = 15;

    var profileRadius = this.profileSize / 2;
    var offsetHeight = profileRadius + (profileRadius / 2);

    var barHeightActual = offsetHeight + (this.results.actual * value);
    var barHeightGenetic = offsetHeight + (this.results.genetic * value);

    var circleRadius = profileRadius / 2;

    // Render the Actual Age bar
    this.baseCanvas.drawRectangle({
      x: this.profilePosition.x,
      y: this.profilePosition.y + profileRadius,
      width: profileRadius,
      height: barHeightActual,
      fill: "#9AC5FF", // Home - Tint 60
    });

    // Render the Actual Age circle
    this.baseCanvas.drawCircle({
      x: this.profilePosition.x + circleRadius,
      y: this.profilePosition.y + profileRadius + barHeightActual,
      radius: circleRadius,
      fill: "#036DFF", // Home
    });

    // Draw the Actual Age amount
    this.baseCanvas.drawText({
      value: this.results.actual,
      x: this.profilePosition.x + circleRadius,
      y: this.profilePosition.y + profileRadius + barHeightActual + circleRadius + 15,
      font: "70px fraktion-medium",
      fill: "#000",
    });

    // Draw the Actual Age label
    this.baseCanvas.drawText({
      value: "Actual",
      x: this.profilePosition.x + circleRadius,
      y: this.profilePosition.y + profileRadius + barHeightActual + circleRadius + 100,
      font: "20px fraktion-medium",
      fill: "#5C5C5D",
    });

    // Get the difference between the results for styling below
    var difference = this.results.genetic - this.results.actual;

    // If genetic is less or equal, the result is green.
    // If genetic is older by 2 or less, the result is orange.
    // If genetic is older by more than 2 years, the result is red.
    var geneticColorBar = difference <= 0
      ? "#99CFB9" : (difference <= 2 ? "#FAC599" : "#F6B6B7");
    var geneticColorCircle = difference <= 0
      ? "#008851" : (difference <= 2 ? "#F36D00" : "#E8494C");

    // Render the Genetic Age bar
    this.baseCanvas.drawRectangle({
      x: this.profilePosition.x + profileRadius,
      y: this.profilePosition.y + profileRadius,
      width: profileRadius,
      height: barHeightGenetic,
      fill: geneticColorBar,
    });

    // Render the Genetic Age circle
    this.baseCanvas.drawCircle({
      x: this.profilePosition.x + profileRadius + circleRadius,
      y: this.profilePosition.y + profileRadius + barHeightGenetic,
      radius: circleRadius,
      fill: geneticColorCircle,
    });

    // Draw the Genetic Age amount
    this.baseCanvas.drawText({
      value: this.results.genetic,
      x: this.profilePosition.x + profileRadius + circleRadius,
      y: this.profilePosition.y + profileRadius + barHeightGenetic + circleRadius + 15,
      font: "70px fraktion-medium",
      fill: "#000",
    });

    // Draw the Genetic Age label
    this.baseCanvas.drawText({
      value: "Genetic",
      x: this.profilePosition.x + profileRadius + circleRadius,
      y: this.profilePosition.y + profileRadius + barHeightGenetic + circleRadius + 100,
      font: "20px fraktion-medium",
      fill: "#5C5C5D",
    });

    this.createProfileImage(null, function() {
      self.callback(self.baseCanvas);
    });

  };

  /**
   * Method to create the profile image for the visualization.
   */
  Service.prototype.createProfileImage = function(canvas, callback) {

    this.profileCanvas = new CanvasContext({
      width: this.profileSize,
      height: this.profileSize,
    });

    var profileElement = this.type === "breed"
      ? document.querySelector(".results-visualization-breed-avatar")
      : document.querySelector(".results-visualization-age-avatar");

    var profileImage = window.getComputedStyle(profileElement)
      .getPropertyValue("background-image")
      .match(/url\(["']?([^"']*)["']?\)/)[1];

    this.profileCanvas.drawImageSrc({
      src: profileImage,
      width: this.profileSize,
      height: this.profileSize,
      callback: this.renderProfileImage.bind(this, canvas, callback),
    });

  };

  /**
   * Method to render the profile image to the base canvas.
   */
  Service.prototype.renderProfileImage = function(canvas, callback) {

    canvas = canvas || this.baseCanvas;

    this.profileCanvas.drawCircularMask({ radius: this.profileSize / 2 });

    canvas.drawImage({
      image: this.profileCanvas.element,
      width: this.profileSize,
      height: this.profileSize,
      x: this.profilePosition.x,
      y: this.profilePosition.y,
    });

    callback && callback();

  };

  // Return as a static class / singleton
  return new Service();

})();

// TODO: Remove this once all inline scripts are removed
window.DataVisualizationService = DataVisualizationService;
